import React, { Component } from "react";
import { Form, Row, Col } from "reactstrap";
import FormComponent from "../../../../common/FormComponent";
import {
  Validator,
  submitValidator,
  refresh,
  valid,
  errors,
} from "../../../../common/Validator";

import CountryCodeList from "./countrycodelist"
import { withRouter } from "react-router-dom";

import DateFns from "date-fns";

import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE,RS_API } from "../../../../utils/config";
import Button from "@material-ui/core/Button";

import { getProfileInfo} from "../../../../redux/action/profileInfoAction"

import { connect } from "react-redux";

/**
 * UpdateProfessional Component for updating the professional details.
 */
class UpdateProffesionalDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      organizationName: this.props.updateDataProp
        ? this.props.updateDataProp.employerName
        : "",
      contactNo: this.props.updateDataProp
        ? this.props.updateDataProp.contactNo
        : "",
      email: this.props.updateDataProp ? this.props.updateDataProp.email : "",
      location: this.props.updateDataProp
        ? this.props.updateDataProp.location
        : "",
      fromDate: this.props.updateDataProp
        ? DateFns.format(this.props.updateDataProp.fromDate, "YYYY-MM-DD")
        : "",
      toDate: this.props.updateDataProp
        ?   !this.props.updateDataProp.toDate?null:DateFns.format(this.props.updateDataProp.toDate, "YYYY-MM-DD")
        : "",
      noOfYears: this.props.updateDataProp
        ? this.props.updateDataProp.noOfYears
        : "",
      designation: this.props.updateDataProp
        ? this.props.updateDataProp.designation
        : "",
        dialingCode:this.props.updateDataProp? this.props.updateDataProp.dialingCode:"+91",
        currentEmployee:this.props.updateDataProp
        ? this.props.updateDataProp.isCurrentEmployeer
        : "",

      todateback: "",
      fromdateback: "",
      dateError: "",
      checkdate: "",
      buttonAction:false,
      errorYear: "",
      toErrorYear: "",
      id: this.props.updateDataProp ? this.props.updateDataProp.id : undefined,
      message: "",
      error: "",
      getCountryCode:[]
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.noOfDaysYears = this.noOfDaysYears.bind(this);
    this.dateOnChange = this.dateOnChange.bind(this);
    this.getCountryData = this.getCountryData.bind(this)
    this.employeeChange = this.employeeChange.bind(this)
    // this.isCheckingDate = this.isCheckingDate.bind(this)
  }
   // common onchange function
  onChange(e) {
    Validator(e.target);
    if(e.target.name === "currentEmployee"){
      if(e.target.value === "Yes"){
        this.setState({
          noOfYears:0,
          toDate:"",
          currentEmployee:e.target.value,
          dateError:"",
          toErrorYear:"",
          buttonAction:false
        })
        }
        else{
          this.setState({
            currentEmployee:e.target.value,
            noOfYears:"",
            buttonAction:false
          })
        }
    }
    else{
      this.setState({
        [e.target.name]: e.target.value,
        buttonAction:false
      });
    }
  }

   // submit function by clicking submit button

  onSubmit(e) {
    e.preventDefault();
    submitValidator(e.target);
    console.log(typeof(this.state.toDate))
    
    let dateFrom =  DateFns.format(this.state.fromDate, "YYYY-MM-DD")
    let dateTo = !this.state.toDate?null:DateFns.format(this.state.toDate, "YYYY-MM-DD")
    
    let data = {
      canInfoId:this.props.profile.data.id,
      employerName: this.state.organizationName,
      contactNo: this.state.contactNo,
      isCurrentEmployeer:this.state.currentEmployee,
      dialingCode:this.state.dialingCode,
      email: this.state.email,
      location: this.state.location,
      fromDate: dateFrom,
      toDate: dateTo,
      noOfYears: Number(this.state.noOfYears),
      designation: this.state.designation,
    };
 
    this.setState({
      buttonAction:true
    })
    if (
      valid &&
      !this.state.dateError &&
      !this.state.toErrorYear &&
      !this.state.errorYear
    ) {
      axios
        .post(`${API_CANDIDATE}/v1/api/can-employment-history`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "successfully created",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }
  // update function by clicking update button
  onUpdate(e) {
    console.log(this.state.id);
    console.log(e, "updating");
    e.preventDefault();
    submitValidator(e.target);
    let dateFrom =  DateFns.format(this.state.fromDate, "YYYY-MM-DD")
    let dateTo = !this.state.toDate?null:DateFns.format(this.state.toDate, "YYYY-MM-DD")

    let data = {
      id: this.state.id,
      canInfoId:this.props.profile.data.id,
      employerName: this.state.organizationName,
      contactNo: this.state.contactNo,
      countryCode:this.state.dialingCode,
      isCurrentEmployeer:this.state.currentEmployee,
      email: this.state.email,
      location: this.state.location,
      fromDate: dateFrom,
      toDate: dateTo,
      noOfYears: Number(this.state.noOfYears),
      designation: this.state.designation,
    };
    this.setState({
      buttonAction:true
    })
    if (
      valid &&
      !this.state.dateError &&
      !this.statetoErrorYear &&
      !this.state.errorYear
    ) {
      axios
        .put(`${API_CANDIDATE}/v1/api/can-employment-history`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "Updated successfully ",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }

  // onchange function for from date and to date

  dateOnChange(e) {

    if (e.target.name === "fromDate") {
      this.setState({
        toDate: "",
        buttonAction:false
      });
      errors.fromDate = "";

      let date = new Date(e.target.value);
      let dateYear = date.getFullYear();


      if ((dateYear.toString().length < 4 || dateYear.toString().length > 4)|| (dateYear > new Date(Date.now()).getFullYear()) )  {
        this.setState({
          errorYear: "Please enter valid date",
          buttonAction:false
        });
      } else {
        this.setState({
          errorYear: "",
          buttonAction:false
        });
      }
    }

    if (e.target.name === "toDate") {
      let dateTo = new Date(e.target.value);
      let dateYearTo = dateTo.getFullYear();

      if (
        (dateYearTo.toString().length < 4 ||
        dateYearTo.toString().length > 4) || (dateYearTo > new Date(Date.now()).getFullYear())
      ) {
      



        this.setState({
          toErrorYear: "Please enter valid date",
          dateError: "",
          buttonAction:false
        });
      } else {
        this.setState({
          toErrorYear: "",
          buttonAction:false
        });
      }

      
     
      if (
        Date.parse(e.target.value) < Date.parse(this.state.fromDate) ||
        !this.state.fromDate
      ) {
        this.setState({
          [e.target.name]: e.target.value,
          dateError: "EndDate must be greater than or equal to StartDate",
          toErrorYear: "",
        });
        errors.toDate = "";
      } else {
        this.setState({
          [e.target.name]: e.target.value,
          dateError: "",
        });
        this.noOfDaysYears(e.target.value);

        errors.toDate = "";
      }
    } else {
      this.setState({
        [e.target.name]: e.target.value,
        noOfYears:0
      });
      errors.fromDate = "";
    }
  }

  // calculation number of years validation

  noOfDaysYears(endDate) {
    let date1 = new Date(this.state.fromDate);
    let date2 = new Date(endDate);

    console.log(date2-date1)

    let differenceTime = Math.abs(date2 - date1) 
    var day = 1000 * 60 * 60 * 24;

    let days = differenceTime / day
    let years = days / 365.25;
    let months = days / 30.427
     if (years.toString().charAt(0) === "0") {
      if (months.toString().charAt(0) === "0") {
       
         this.setState({
           noOfYears: 0.0,
         });
      }
      else{
        this.setState({
          noOfYears: 0.0
        });
      
      }
    } else {
      
       this.setState({
        noOfYears: `${ years.toFixed(1)} `
      });
    }

 
  }
  // get country code data
  getCountryData() {
    axios
      .get(`${RS_API}/v1/api/can-country`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
          getCountryCode: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // onchange function for is current employer

  employeeChange(e){
  
   

  }

  componentDidMount() {
    this.props.getProfileInfo()
    this.getCountryData();
    refresh();
    this.setState({
      message: "",
      error: "",
    });
  }

  render() {
  
    const {
      organizationName,
      contactNo,
      email,
      location,
      fromDate,
      toDate,
      noOfYears,
      designation,
      message,
      error,
    } = this.state;

    return (
      <>
       {/* applied ternary operator for checking whether it is update or submit form */}
        {!this.props.updateDataProp ? (
          <div style={{ paddingLeft: "2.5rem" }}>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span>Professional Experience</span>
              </div>
              <div>
                <Form onSubmit={this.onSubmit} className="p-3" noValidate>
                  <Row>
                    <Col md="6">
                     
                      <FormComponent
                        index="1"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label="Employer Name"
                        type="textarea"
                        name="organizationName"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={organizationName}
                        change={this.onChange}
                        required={true}
                      />
                       <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "8px",
                        }}
                      >
                        <span style={{ fontSize: "17px", fontWeight: "bold" }}>
                          Is Your Current Employer ?
                        </span>
                        <select
                         tabIndex="4"
                          style={{
                            height: "50px",
                            marginTop: "10px",
                            outline: "none",
                            borderColor: "grey",
                          }}
                          value={this.state.currentEmployee}
                          name="currentEmployee"
                          // id={this.state.serving}
                          required={true}
                          onChange={this.onChange}
                        >
                          <option value="" hidden>
                            Select
                          </option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.currentEmployee ?errors.currentEmployee:"" }
                        </span>
                      </div>

                      <FormComponent
                        index="6"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label=" Employer Email Id"
                        type="email"
                        name="email"
                        inputClass="form-control-sm"
                        value={email}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="8"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label="From Date"
                        type="date"
                        name="fromDate"
                        inputClass="form-control-sm"
                        value={fromDate}
                        maxlength="4"
                        max={"9999-12-31"}
                        change={this.dateOnChange}
                        required={true}

                        // min={DateFns.format(new Date(), "YYYY-MM-DD").toString()}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>
                      <FormComponent
                        index="10"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label="Number Of Years "
                        type="textarea"
                        inputClass="form-control-sm"
                        value={noOfYears}
                        required={true}
                      />

                      {/* {errors && errors.single ?<span style={{color:"red",fontSize:"14px"}}>{errors.single}</span>:""} */}
                    </Col>
                    <Col md="6">
                      <span className="bold label-sm"> Contact No.</span>
                      <div style={{ display: "flex", width: "100%",marginTop:"0.5rem" }}>
                        <CountryCodeList
                          tab="2"
                          widthValue="60px"
                          getCountryCode={this.state.getCountryCode}
                          value={this.state.dialingCode}
                          // value={this.state.dialingCode}
                          onChange={(e) =>
                            this.setState({
                              dialingCode: e.target.value,
                            })
                          }

                          // countries={countries}
                        />
                        <div style={{width:"100%"}}>
                        <FormComponent
                        index="3"
                          style={{
                            height: "50px",
                            width: "100%",
                            marginTop: "10px",
                          }}
                          labelClass="bold label-sm"
                          // label="Contact Number"
                          type="tel"
                          name="contactNo"
                          inputClass="form-control-sm"
                          value={contactNo}
                          change={this.onChange}
                          required={true}
                        />
                        </div>
                      </div>
                      <FormComponent
                        index="5"
                        style={{ marginTop: "10px", fontsize: "16px" }}
                        labelClass="bold label-sm"
                        label="Location"
                        type="textarea"
                        name="location"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={location}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="7"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label="Designation"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="designation"
                        inputClass="form-control-sm"
                        value={designation}
                        change={this.onChange}
                        required={true}
                      />

                      {this.state.currentEmployee === "Yes" ? null : (
                        <FormComponent
                         index="9"
                          style={{ marginTop: "10px", height: "50px" }}
                          labelClass="bold label-sm"
                          label="To Date"
                          type="date"
                          name="toDate"
                          inputClass="form-control-sm"
                          value={toDate}
                          change={this.dateOnChange}
                          required={true}
                          min={this.state.fromDate}
                        />
                      )}
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.dateError}
                      </span>
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>
                    </Col>
                    </Row>

                    <div className="center">
                      <Button
                       tabIndex="10"
                        disabled={this.state.buttonAction}
                        type="submit"
                        style={{
                          background: "#0984e3",
                          marginTop: "25px",
                          color: "white",
                        }}
                        className="btn login-button white-text"
                      >
                        Submit
                      </Button>
                    </div>
               
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span>Professional Experience</span>
              </div>
              <div>
                <Form onSubmit={this.onUpdate} className="p-3" noValidate>
                <Row>
                    <Col md="6">
                     
                      <FormComponent
                        index="1"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label="Employer Name"
                        type="textarea"
                        name="organizationName"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={organizationName}
                        change={this.onChange}
                        required={true}
                      />
                       <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "8px",
                        }}
                      >
                        <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                          Is Your Current Employer ?
                        </span>
                        <select
                         tabIndex="4"
                          style={{
                            height: "50px",
                            marginTop: "10px",
                            outline: "none",
                            borderColor: "grey",
                          }}
                          value={this.state.currentEmployee}
                          name="currentEmployee"
                          // id={this.state.serving}
                          required={true}
                          onChange={this.onChange}
                        >
                          <option value="" hidden>
                            Select
                          </option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.currentEmployee ?errors.currentEmployee:"" }
                        </span>
                      </div>

                      <FormComponent
                        index="6"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label=" Employer Email Id"
                        type="email"
                        name="email"
                        inputClass="form-control-sm"
                        value={email}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="8"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label="From Date"
                        type="date"
                        name="fromDate"
                        inputClass="form-control-sm"
                        value={fromDate}
                        maxlength="4"
                        max={"9999-12-31"}
                        change={this.dateOnChange}
                        required={true}

                        // min={DateFns.format(new Date(), "YYYY-MM-DD").toString()}
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.errorYear}
                      </span>
                      <FormComponent
                        index="10"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label="Number Of Years "
                        type="textarea"
                        inputClass="form-control-sm"
                        value={noOfYears}
                        required={true}
                      />

                      {/* {errors && errors.single ?<span style={{color:"red",fontSize:"14px"}}>{errors.single}</span>:""} */}
                    </Col>
                    <Col md="6">
                      <span className="bold label-sm"> Contact No.</span>
                      <div style={{ display: "flex", width: "100%",marginTop:"0.5rem" }}>
                        <CountryCodeList
                          tab="2"
                          widthValue="60px"
                          getCountryCode={this.state.getCountryCode}
                          value={this.state.dialingCode}
                          // value={this.state.dialingCode}
                          onChange={(e) =>
                            this.setState({
                              dialingCode: e.target.value,
                            })
                          }

                          // countries={countries}
                        />
                        <div style={{width:"100%"}}>
                        <FormComponent
                        index="3"
                          style={{
                            height: "50px",
                            width: "100%",
                            marginTop: "10px",
                          }}
                          labelClass="bold label-sm"
                          // label="Contact Number"
                          type="tel"
                          name="contactNo"
                          inputClass="form-control-sm"
                          value={contactNo}
                          change={this.onChange}
                          required={true}
                        />
                        </div>
                      </div>
                      <FormComponent
                        index="5"
                        style={{ marginTop: "10px", fontsize: "16px" }}
                        labelClass="bold label-sm"
                        label="Location"
                        type="textarea"
                        name="location"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={location}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="7"
                        style={{ marginTop: "10px", height: "50px" }}
                        labelClass="bold label-sm"
                        label="Designation"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="designation"
                        inputClass="form-control-sm"
                        value={designation}
                        change={this.onChange}
                        required={true}
                      />

                      {this.state.currentEmployee === "Yes" ? null : (
                        <FormComponent
                         index="9"
                          style={{ marginTop: "10px", height: "50px" }}
                          labelClass="bold label-sm"
                          label="To Date"
                          type="date"
                          name="toDate"
                          inputClass="form-control-sm"
                          value={toDate}
                          change={this.dateOnChange}
                          required={true}
                          min={this.state.fromDate}
                        />
                      )}
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.dateError}
                      </span>
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>
                    </Col>
                    </Row>
                  <div className="center">
                    <Button
                      disabled={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "20px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Update
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}





const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(
  withRouter(UpdateProffesionalDetails)
);
